import { RoleEnum } from '../../types/enums/users/role.enum'
import { User } from '../../types/models/users/user'

// Only staff users have a picture sent with the connected user, every other role gets the default one
export const getUserImage = (user?: User | null) => {
  if (user?.role === RoleEnum.STAFF && user.staff?.picture?.path) return user.staff.picture.path

  return '/profile-default.jpg'
}

// A local organiser account has no first name when its presta is a company (gender "Société"), so
// the first name stays optional for it; every other role keeps a required first name
export const isUserFirstNameOptional = (user?: Pick<User, 'role'> | null) =>
  user?.role === RoleEnum.Ol

// French elision of "de" before a first name: "d'Alain", "d'Ève", but "de Hugo" (names starting
// with "H" keep "de" on purpose) and "de -" when there is no name
export const withFrenchDe = (firstName: string) => {
  const startsWithVowel = /^[aeiouy]/i.test(firstName.normalize('NFD'))

  return startsWithVowel ? `d'${firstName}` : `de ${firstName}`
}
